import defaultAnswer from "./defaultanswer";
import addAddButton from "./addaddbutton";

export default function removeAnswer(element){

    var divID           = $(element).data('id');
    var answer_count    = $('#' + divID + ' .answerswrap').length;
    
    if(answer_count > 1) {
        
        $(element).closest('.answerswrap').remove();
        
    }

    addAddButton(element);
    defaultAnswer(divID);
    
}